import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Holiday Management Service
 * !== 휴일 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/crtr/hldy`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/crtr/hldy-mgmt`,
    nodes: [{ label: "Portal" }, { label: "Criteria Information Management" }, { label: "Holiday Management" }],
};

export const URLS = {
    ptli0408001q: `${BASE.path}/ptli0408001q`, // Holiday Management List !== 휴일 관리 목록 ==!
    ptli0408002s: `${BASE.path}/ptli0408002s`, // Holiday Management Registration !== 휴일 관리 등록 ==!
    ptli0408003s: `${BASE.path}/ptli0408003s`, // Holiday Management Modification !== 휴일 관리 수정 ==!
};

export const APIS = {
    // Retrieve a list of Holiday management. !== 휴일관리 목록을 조회한다.==!
    getHldyMgmtList: (data: any, page: number, size: number) => {
        if (!comnUtils.isEmpty(data.startDate)) data.startDate = data.startDate.split("-").join("");
        if (!comnUtils.isEmpty(data.endDate)) data.endDate = data.endDate.split("-").join("");

        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Retrieve Holiday Management information. !== 휴일관리 정보를 조회한다.==!
    getHldyMgmtInfo: (hldyId: any) => api.get(`${BASE.api}/${hldyId}`),

    // Save Holiday Management information !== 휴일관리 정보 저장 ==!
    insertHldyMgmtInfo: (data: any) => {
        if (!comnUtils.isEmpty(data.ctraDt)) data.ctraDt = data.ctraDt.split("-").join("");

        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Modify Holiday Management information !== 휴일관리 정보 수정 ==!
    updateHldyMgmtInfo: (data: any) => {
        if (!comnUtils.isEmpty(data.ctraDt)) data.ctraDt = data.ctraDt.split("-").join("");

        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    deleteHldyMgmtInfo: (hldyId: any) => api.delete(`${BASE.api}/${hldyId}`),
};

// Holiday Management Search Form !== 지역 코드 관리 검색 폼 ==!
export const SF_HLDY_MGMT_SRCH: TFormSchema = {
    id: "form_hldyMgmtSrch",
    schema: {
        ctraDt: {
            type: "daterange",
            label: "L_CTRA_DT",
            start: { name: "startDate" },
            end: { name: "endDate" },
            rangeButton: 0,
        },
        hldyTpCd: {
            type: "select",
            label: "L_HLDY_TP_CD",
            area: "comnCd",
            comnCd: "COM0057",
        },
        hldyNm: { type: "text", label: "L_HLDY_NM" },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", maxLength: 5 },
    },
};

// Holiday Management List Grid Schema !== 휴일 관리 목록 그리드 스키마 ==!
export const SG_HLDY_MGMT_LIST: TGridSchema = {
    id: "grid_hldyMgmtList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        // { cells: [{ header: "L_HLDY_ID", binding: "hldyId", width: "*" }] },
        { cells: [{ header: "L_CTRA_DT", binding: "ctraDt", width: "*" }] },
        { cells: [{ header: "L_HLDY_NM", binding: "hldyNm", width: "*" }] },
        { cells: [{ header: "L_HLDY_TP_CD", binding: "hldyTpCd", width: "*" }] },
        { cells: [{ header: "L_DAYS", binding: "day", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "hldyTpCd", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "hldyId", edit: false }] },
        { cells: [{ binding: "ctraDt", edit: false, type: "date" }] },
        { cells: [{ binding: "hldyNm", edit: false, align: "left" }] },
        {
            cells: [
                { binding: "hldyTpCd", edit: false, align: "left", type: "code", area: "comnCd", comnCd: "COM0057" },
            ],
        },
        { cells: [{ binding: "day", edit: false, align: "left" }] },
        { cells: [{ binding: "cstmOfceCd", edit: false, align: "left", type: "code", area: "cstmCd" }] },
    ],
};

// Holiday Management Form !== 지역 코드 관리 폼 ==!
export const SF_HLDY_MGMT_INFO: TFormSchema = {
    id: "form_HldyMgmtInfo",
    schema: {
        hldyNm: {
            type: "text",
            label: "L_HLDY_NM",
            required: true,
            maxLength: 50,
            letterCase: "upper",
        },
        ctraDt: { type: "date", label: "L_CTRA_DT", required: true, area: "ctraDt" },
        hldyTpCd: {
            type: "select",
            label: "L_HLDY_TP_CD",
            required: true,
            area: "comnCd",
            comnCd: "COM0057",
        },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE_CD", area: "cstmCd", popupSize: "md" },
    },
};
